import React from "react";
import { TableBody } from "@mui/material";

import { useGetRolesTable } from "../../hooks";
import RolePermissionsTableRow from "./RolePermissionsTableRow";

const RolePermissionsTableBody = ({ locationId }) => {
  const { data } = useGetRolesTable({ locationId });
  const roles = data?.roles || [];
  const permissions = data?.permissions || [];

  return (
    <TableBody>
      {permissions?.map((group) => (
        <RolePermissionsTableRow key={group.id} group={group} roles={roles} />
      ))}
    </TableBody>
  );
};

export default RolePermissionsTableBody;
